class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange(e) {
      this.updateOptions();
      this.currentVariant();
      this.updateVaraintImage(e.target);
      this.updateVariantId()
      this.updatePrice();
      this.availabality();
    }
  
    getVariantData() {
      return JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      );
    }
  
    updateOptions() {
      const selectedOptions = [];
      [...this.querySelectorAll('select, input')].map((element) => {
        if (element.tagName === 'SELECT') {
          return element; 
        } else if (element.type === 'radio' && element.checked) {
          return element; 
        }
        return null; 
      }).filter(element => {
        if(element !== null) {
          let position = Number(element.getAttribute('data-option-position'));
          selectedOptions[position - 1] = element.value;
        }
      });
      return selectedOptions;
    }  
  
    updateVaraintImage() {
      const currentVariant = this.currentVariant();
      const variantImgEl = this.closest('[js-product-card]').querySelector("[js-variant-image-wrapper] img");

      if(bundleProductVariantCustomDatas[currentVariant.id]?.alternateImage) {
        if(variantImgEl) {
          variantImgEl.setAttribute("src", bundleProductVariantCustomDatas[currentVariant.id].alternateImage);
          variantImgEl.setAttribute("srcset", bundleProductVariantCustomDatas[currentVariant.id].alternateImage);
          variantImgEl.setAttribute("data-srcset", bundleProductVariantCustomDatas[currentVariant.id].alternateImage);
        }
      } else {
        if(variantImgEl && currentVariant.featured_image?.src) {
          variantImgEl.setAttribute("src", currentVariant.featured_image?.src);
          variantImgEl.setAttribute("srcset", currentVariant.featured_image?.src);
          variantImgEl.setAttribute("data-srcset", currentVariant.featured_image?.src);
        }
      }
    }
  
    currentVariant() {
      const options = this.updateOptions();
      return this.getVariantData().find((variant) => {
        const match = !variant.options.map((option, index) => {
          const isMatch = options[index] === option;
          return isMatch;
        }).includes(false);
        return match;
      });
    }

    availabality() {
      const variantsData = this.getVariantData();
      const currentVariant = this.currentVariant();

      const customDropdownLis = document.querySelectorAll('custom-dropdown .select-options li');

      customDropdownLis.forEach(option => {
        const position  = parseInt(option.getAttribute("data-option-position"));
        const optionValue = option.getAttribute("data-option-value");
        variantsData.forEach(variant => {
          if (variant.available && optionValue === variant[`option${position}`] && variant.id == currentVariant.id) {
            option.removeAttribute('disabled');
          } 
          if (variant.available === false && optionValue === variant[`option${position}`] && variant.id == currentVariant.id) {
            option.setAttribute('disabled', true);
          }
        })
      })
      
    }

    updateVariantId() {
        const currentVariant = this.currentVariant();
        const parent = this.closest('[js-product-card]');
        const productId = parent.getAttribute('data-product-id');
        const position = parent.getAttribute('data-position');

        const variantIdInputs = document.querySelectorAll(`product-bundle [data-input-variant-id="${productId}_${position}"]`)

        variantIdInputs.forEach(input => {
          input.setAttribute('value', currentVariant.id)
        })

        this.updateQuantity();
        this.updateDeliveryDate(currentVariant);
    }

    updateQuantity() {
      const parent = this.closest('product-bundle');
      const itemidInputs = parent.querySelectorAll('[js-item-id-input]');
      let quantity = 0;

      itemidInputs.forEach(input => {
        const variantId = input.value;
        const productId = input.getAttribute('data-item-id');
        const sameVarantArrayLength = parent.querySelectorAll(`[js-item-id-input][value="${variantId}"]`)?.length;

        if(quantity < sameVarantArrayLength) {
          quantity = sameVarantArrayLength;
          parent.querySelectorAll(`[js-item-quantity-input][data-item-id="${productId}"]`)?.forEach(quantityInput => {
            quantityInput.value = quantity;
          })
        }

      })
    }

    updateDeliveryDate(currentVariant) {
      const parent = this.closest('[js-product-card]');
      const deliveryDateTag = parent.querySelector('[js-bundle-delivery-wrappery]');
      if(deliveryDateTag && bundleProductVariantCustomDatas[currentVariant.id]) {
        deliveryDateTag.innerHTML = `* ${bundleProductVariantCustomDatas[currentVariant.id].availibilityText}`;
      }
    }

    updatePrice() {
      const bundleInfo = window.bundleInfo;
      const currentVariant = this.currentVariant();
      const parent = this.closest('[js-product-card]');
      parent.setAttribute('data-current-variant-price', currentVariant.price)

      const productCards = this.closest('product-bundle').querySelectorAll('.active[js-product-card]');
      let bundleOriginalPrice = bundleInfo.mainProductPrice;

      productCards.forEach(productCard => {
        const variantPrice = parseFloat(productCard.getAttribute('data-current-variant-price'));
        bundleOriginalPrice += variantPrice
      })

      let bundleDiscountPrice = ((100 - bundleInfo.discount) / 100 * bundleOriginalPrice);

      const formatMoney = (val => this.closest('product-bundle').formatMoney(val, window.theme.moneyFormat || '${{amount}}'));

      document.querySelectorAll('[js-bundle-product-discounted-price]').forEach(priceTag => {
        priceTag.innerHTML = `${formatMoney(bundleDiscountPrice)}`
      })

      document.querySelectorAll('[js-bundle-product-original-price]').forEach(priceTag => {
        priceTag.innerHTML = `${formatMoney(bundleOriginalPrice)}`
      })
  
    }

  }
  
  customElements.define("variant-selects", VariantSelects);